function Bell() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40.506"
      height="40.506"
      viewBox="0 0 40.506 40.506"
      aria-label="알림"
    >
      <desc>알림</desc>
      <defs>
        <clipPath id="b1cs8nqwfa">
          <path
            fill="#fff"
            stroke="#666"
            strokeWidth="3"
            d="M0 0h40.506v40.506H0z"
            data-name="사각형 9267"
          ></path>
        </clipPath>
      </defs>
      <g data-name="마스크 그룹 198">
        <g clipPath="url(#b1cs8nqwfa)" data-name="그룹 11232">
          <g fill="#fff" data-name="그룹 11231">
            <g
              stroke="#ddd"
              strokeWidth="3"
              data-name="타원 1083"
              transform="translate(13.967 25.343)"
            >
              <circle cx="6.072" cy="6.072" r="6.072" stroke="none"></circle>
              <circle cx="6.072" cy="6.072" r="4.572" fill="none"></circle>
            </g>
            <g data-name="합치기 132">
              <path d="M32.615 29.914H7.461a.606.606 0 01-.596-.613c0-.338.267-.612.596-.612h1.5V16.525a11 11 0 013.245-7.833 11.005 11.005 0 017.833-3.245c2.958 0 5.74 1.152 7.832 3.245a11.006 11.006 0 013.244 7.833v12.164h1.5c.329 0 .596.274.596.612a.606.606 0 01-.596.613z"></path>
              <path
                fill="#ddd"
                d="M29.615 28.414v-11.89c0-5.279-4.296-9.577-9.576-9.577-5.281 0-9.578 4.296-9.578 9.578v11.89h19.154m3 3H7.461A2.105 2.105 0 015.365 29.3c0-1.166.939-2.112 2.096-2.112V16.525c0-6.948 5.631-12.578 12.578-12.578 6.946 0 12.576 5.631 12.576 12.578v10.664c1.159 0 2.096.945 2.096 2.112a2.104 2.104 0 01-2.096 2.113z"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Bell
